// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","appLoading":"App_appLoading__-gQHW"};